<template>
    <div class="TQ_center">

        <tq-tabs :p_display_lang-code_e="ps_langCode_e"
                 :p_selected-tab-index_vn="selectedTabIndex_vn"
                 :p_tabs_ao="co_introTabs_ao"
                 p_att_s="title_s"

                 :p_vertical-layout_b="true"
                 p_padding-body_s="8px"
                 p_tabs-class_s="TQ_text_18px TQ_padding_8px_16px">

            <!-- text area -->
            <div class="TQ_inline TQ_margin_8px TQ_width_100p TQ_maxWidth_350px TQ_padding_4px"
                 v-if="co_introTabs_ao"
                 :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                 v-for="langCode in pb_questExplore_c.qex_langArr_ae">

                <div class="TQ_text_24px"> {{format_langCode(langCode)}} </div>

                <!--<tq-textarea-->
                <!--        :key="selectedTabIndex_vn.val"-->
                <!--        :pb_uid_s="pb_uid_s"-->
                <!--        pb_textarea-class_s="TQ_text_16px TQ_box_shadow TQ_padding_8px"-->
                <!--        :pb_init-text_s="co_introTabs_ao[selectedTabIndex_vn.val].initValue_blc_s[langCode]"-->
                <!--        :pb_max-length_n="co_introTabs_ao[selectedTabIndex_vn.val].maxLength_n"-->
                <!--        :pb_placeholder_s="co_introTabs_ao[selectedTabIndex_vn.val].placeholder_blc_s[langCode]"-->
                <!--        :pb_rows_n="20"-->
                <!--        :pe_change-text_s="(text_s) => {co_introTabs_ao[selectedTabIndex_vn.val].initValue_blc_s[langCode] = text_s}"-->
                <!--/>-->

                <tq-wysiwyg-editor :id="'editEmail_' + selectedTabIndex_vn.val + '_' + langCode"
                                   :p_value_html="co_introTabs_ao[selectedTabIndex_vn.val].initValue_blc_s[langCode]"
                                   :pe_update-value_f="(newValue_html) => {co_introTabs_ao[selectedTabIndex_vn.val].initValue_blc_s[langCode] = newValue_html}"
                                   :pe_choose-file_f="m_editorChooseFile_f"/>


            </div>

        </tq-tabs>

        <!-- Choose file -->
        <tq-popup :show="popup_chooseFile_show_vb" width="100%" class="TQ_center" padding="0" :show-close-btn="true">
            <fcuc-drive v-if="popup_chooseFile_show_vb.val"
                            :p_can-choose-image_b="true"
                            :p_can-choose-video_b="false"
                            :p_can-choose-audio_b="false"
                            :pe_choose-file_f="m_chooseFile_f"/>
        </tq-popup>

    </div>
</template>

<script>
    import {FB_QuestExplore} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import WysiwygEditor from "../../../../components/complex/TqWysiwygEditor";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from "../../../../components/basic/TqCard";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {helper_getDirectionByLangCode_fe} from "../../../../scripts/S_Helper";
    import TqTextarea from "../../../../components/basic/TqTextarea";
    import TqTabs from "../../../../components/basic/TqTabs";
    import {
        validator_enum_fb,
    } from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqWysiwygEditor from "@/components/complex/TqWysiwygEditor";
    import TqPopup from "@/components/basic/TqPopup";
    import FcucDrive from "@/components/unpure/FcucDrive";

  export default {

      name: "C_Creator_EditQuests_Item_Explore_Emails",
      components:{
          FcucDrive,
          TqPopup,
          TqWysiwygEditor,
          TqTabs,
          TqTextarea,
          TqCard,
          WysiwygEditor,
      },
      props:{

          ps_langCode_e :{
              type: String,
              require: true,
              validator(val){
                  return validator_enum_fb(enum_langCodes, val)
              }

          },
          pb_uid_s:{
              type:String,
              require: true
          },
          pb_questExplore_c :{
              type: FB_QuestExplore,
              require: true,
          },


      },
      data(){
          return{
              selectedTabIndex_vn : {val : 0},
              popup_chooseFile_show_vb : {val : false},
              popup_chooseFile_cb_f : () => {},

              // imports
              ass_strings : ass_strings,
              format_langCode : format_langCode_fs,
              helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe
          }
      },
      computed: {
          co_introTabs_ao(){
              return [
                  {
                      title_s           : ass_strings.twoWords_purchaseTicket,
                      placeholder_blc_s : ass_strings.fourWords_messageAfterPerchanceTicket,
                      initValue_blc_s   : this.pb_questExplore_c.qex_emailBoughtTicket_blc_html,
                  },
                  {
                      title_s           : ass_strings.twoWords_questFinish,
                      placeholder_blc_s : ass_strings.fourWords_messageAfterFinishQuest,
                      initValue_blc_s   : this.pb_questExplore_c.qex_emailFinishQuest_blc_html,
                  },
              ]
          }
      },
      methods:{
          // wysiwyg choose file
          m_editorChooseFile_f(cb_f){
              this.popup_chooseFile_cb_f = cb_f
              this.popup_chooseFile_show_vb.val = true
          },
          m_chooseFile_f(file_c){
              this.popup_chooseFile_show_vb.val = false
              this.popup_chooseFile_cb_f(file_c)
          },
      }

  }
</script>

<style scoped lang="scss">


</style>
